import React, { useState, useEffect } from 'react'
import './ReportParamPanel.css'
import ReportParamInput from './ReportParamInput'
import { ReportParam, ReportParamValueType } from '../store/store'
import FilterPanel from '../../../components/layout/FilterPanel'
import { useTranslation } from 'react-i18next'

type Props = {
  initialParams: ReportParam[]
  updateParams: (params: ReportParam[]) => void
}

function ReportParamPanel(props: Props) {
  const { initialParams, updateParams } = props
  const [params, setParams] = useState<ReportParam[]>([])
  const { t } = useTranslation(['reports','global'])

  function setParam(key: string, value: ReportParamValueType) {
    setParams(params.map(param => (param.key === key ? { ...param, value: value } : param)))
  }

  function canRun() {
    return params.every(p => p.value !== '' && p.value !== undefined)
  }

  function runReport() {
    if (canRun()) {
      updateParams(params)
    }
  }

  useEffect(() => {
    setParams(initialParams)
  }, [initialParams])

  if (params.length === 0) {
    return (
      <FilterPanel>
        <p>{t('no_params')}</p>
      </FilterPanel>
    )
  } else {
    return (
      <FilterPanel>
        <div id="report-params" className="padding-s">
          {params.map(param => {
            return (
              <ReportParamInput
                key={param.key}
                id={param.key}
                label={param.label}
                type={param.type}
                value={param.value}
                setParam={setParam}
              />
            )
          })}
        </div>
        <div className="padding-s">
          <button id="run-report" disabled={!canRun()} onClick={runReport}>
            {t('global:apply') }
          </button>
        </div>
      </FilterPanel>
    )
  }
}

export default ReportParamPanel
